import classNames from 'classnames';
import React from 'react';

import Close from '~public/static/images/icons/Close.svg';
import DropdownArrow from '~public/static/images/icons/dropdown_arrow_white.svg';
import ProductsIcon from '~public/static/images/icons/icon_all-categories.svg';

import styles from './NavToggle.module.scss';
import { NavToggleProps } from './NavToggle.types';

export const NavToggle = ({
  active,
  setActive,
  children,
  className,
  mod,
}: NavToggleProps) => {
  return (
    <button
      onClick={setActive}
      className={classNames(styles.navToggle, className, {
        [styles.active]: active,
        [styles[mod]]: mod,
      })}
    >
      <span className={styles.iconToggle} />
      {active ? (
        <Close className={styles.iconClose} />
      ) : (
        <ProductsIcon className={styles.iconProduct} />
      )}
      {children}
      <DropdownArrow className={styles.iconArrow} />
    </button>
  );
};
